module.exports = __webpack_public_path__ + "img/Skilled Communicator.8877b590.svg";